import React from "react"
import { useAtomValue } from "jotai"
import { AnimatePresence, motion } from "framer-motion"
import { transitions } from "@/utils/animation"
import { dialogsAtom } from "@/store/dialogs-state"
import { uuid } from "@/utils/uuid"
import clsx from "clsx"

const dialogAnimation = {
	initial: { scale: 0.9, opacity: 0 },
	animateOver: { scale: 1, opacity: 1 },
	animateBehind: { scale: 0.9, opacity: 1 },
	exit: { scale: 0.9, opacity: 0 },
}

export const DialogManager = () => {
	const dialogs = useAtomValue(dialogsAtom)

	return (
		<AnimatePresence>
			{!!dialogs.length && (
				<motion.div
					key="backdrop"
					className="absolute inset-0 z-50"
					animate={{ backgroundColor: "rgba(0,0,0,0.5)" }}
					initial={{ backgroundColor: "rgba(0,0,0,0)" }}
					exit={{ backgroundColor: "rgba(0,0,0,0)", pointerEvents: "none" }}
					transition={transitions.smoothEaseOut}
				/>
			)}

			{dialogs.map(([Component, props], index) => (
				<motion.div
					key={`${getComponentKey(Component)}-${index}`}
					className={clsx(index < dialogs.length - 1 && "hidden", "fixed inset-0 z-50")}
					initial={dialogAnimation.initial}
					animate={
						index === dialogs.length - 1
							? dialogAnimation.animateOver
							: dialogAnimation.animateBehind
					}
					exit={dialogAnimation.exit}
					transition={transitions.smoothEaseOut}
				>
					<Component {...props} />
				</motion.div>
			))}
		</AnimatePresence>
	)
}

const componentKeys = new Map<React.FC<any>, string>()

function getComponentKey(component: React.FC<any>) {
	let id = componentKeys.get(component)

	if (!id) {
		id = uuid()
		componentKeys.set(component, id)
	}

	return id
}
